import React from 'react';
import PropTypes from 'prop-types';
import { Testimonial } from './Testimonial';
import { Carousel } from './Carousel';
import classNames from 'classnames';

export const TestimonialCarousel = ({
  testimonials,
  testimonialCarouselTitle,
  carouselStyleClasses,
}) => {
  const testimonialSliderSettings = {
    arrows: true,
    centerMode: true,
    autoplay: true,
    centerPadding: '0px',
    className: 'testimonial-carousel',
    dots: false,
  };

  carouselStyleClasses = classNames(
    'scalable-content-section testimonial-carousel-section',
    carouselStyleClasses
  );
  return (
    <div className={carouselStyleClasses}>
      <h3 className="testimonial-carousel__title">
        {testimonialCarouselTitle}
      </h3>
      <Carousel options={testimonialSliderSettings}>
        {testimonials.map((testimonial, i) => {
          return <Testimonial key={i} {...testimonial} />;
        })}
      </Carousel>
    </div>
  );
};

TestimonialCarousel.propTypes = {
  testimonials: PropTypes.arrayOf(PropTypes.object),
  testimonialCarouselTitle: PropTypes.string,
  carouselStyleClasses: PropTypes.arrayOf(PropTypes.string),
};
